import { render, staticRenderFns } from "./ProductPackagePanel.vue?vue&type=template&id=7b35523c&scoped=true&"
import script from "./ProductPackagePanel.vue?vue&type=script&lang=js&"
export * from "./ProductPackagePanel.vue?vue&type=script&lang=js&"
import style0 from "./ProductPackagePanel.vue?vue&type=style&index=0&id=7b35523c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b35523c",
  null
  
)

export default component.exports